export default ({ request }) => ({
  masterLocationLeftListApi(data = {}) {
    return request({
      url: '/master/masterStorageLocation/list',
      method: 'post',
      data,
    })
  },
  masterLocationDetailApi(data = {}) {
    return request({
      url: '/master/masterStorageLocation/detail',
      method: 'post',
      data,
    })
  },
  masterLocationSaveApi(data = {}) {
    return request({
      url: '/master/masterStorageLocation/save',
      method: 'post',
      data,
    })
  },
  masterLocationWarehouseDetailApi(data = {}) {
    return request({
      url: '/master/masterStorageLocation/warehouseDetail',
      method: 'post',
      data,
    })
  },
  masterLocationDelApi(data = {}) {
    return request({
      url: '/master/masterStorageLocation/del',
      method: 'post',
      data,
    })
  },
  masterLocationGenerateApi(data = {}) {
    return request({
      url: '/master/masterStorageLocation/generate',
      method: 'post',
      data,
      timeout: 30000,
    })
  },
})
